import { Route } from '@angular/router';
import { authGuard } from '../guards/auth.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./pages/login/login.page'),
  },
  {
    path: 'list',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/inspection/inspection.page'),
  },
  {
    path: 'inspection/payment',
    loadComponent: () =>
      import('./pages/inspection/payment-progress/payment-progress.page'),
  },
];
